var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconParking = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M9 7.5C9 7.086 9.336 6.75 9.75 6.75H12.0472C14.412 6.75 15.7507 7.9395 15.7507 10.125C15.7507 12.3105 14.412 13.5 12.0472 13.5C12.039 13.5 12.0315 13.5 12.024 13.5C12.0165 13.5 12.0082 13.5 12.0007 13.5H10.5008V16.5C10.5008 16.914 10.1648 17.25 9.75075 17.25C9.33675 17.25 9.00075 16.914 9.00075 16.5V7.5H9ZM12.0472 8.25H10.5V12H12C12.0082 12 12.0158 12 12.0233 12C12.0308 12 12.039 11.9992 12.0465 11.9992C13.6193 11.9992 14.25 11.439 14.25 10.1242C14.25 8.8095 13.62 8.24925 12.0465 8.24925L12.0472 8.25Z", fill: "black" }),
            React.createElement("path", { d: "M21.75 5.25C21.75 3.5925 20.4075 2.25 18.75 2.25H5.25C3.5925 2.25 2.25 3.5925 2.25 5.25V18.75C2.25 20.4075 3.5925 21.75 5.25 21.75H18.75C20.4075 21.75 21.75 20.4075 21.75 18.75V5.25ZM5.25 3.75H18.75C19.5795 3.75 20.25 4.4205 20.25 5.25V18.75C20.25 19.5795 19.5795 20.25 18.75 20.25H5.25C4.4205 20.25 3.75 19.5795 3.75 18.75V5.25C3.75 4.4205 4.4205 3.75 5.25 3.75Z", fill: "black" }))),
        alt: 'Icon Parking',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconParking;
//# sourceMappingURL=index.js.map